import React, { useEffect, useState } from 'react'
import { Col, Container, Form, Row, Button, Spinner } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { updateWrapUpAction, generateNote, setEditNote, updateAssembledNote } from '../../../redux/actions/ccp'
import { filterActionsByActionType } from '../../../utils/helpers'

const isChecked = (rules, actions, actionId) => {
  const actionIds = [].concat(...rules.map((rule) => rule.activeActionIds), ...rules.map((rule) => rule.activeSubActionIds))
  return actionIds.includes(actionId)
}

const WrapUp = () => {
  const [orders, setOrders] = useState([])
  const [scheduling, setScheduling] = useState([])
  const [rx, setRx] = useState([])
  const [patientEd, setPatientEd] = useState([])
  const [orderReferrals, setOrderReferrals] = useState([])
  const [noteEdited, setNoteEdited] = useState(false)

  const dispatch = useDispatch()

  const {
    actions,
    rules,
    encounter,
    editing,
    assembledNote,
    subActions,
    createAssembledNote
  } = useSelector((state) => ({
    actions: state.ccp.actions,
    rules: state.ccp.rules,
    encounter: state.patient.encounter,
    editing: state.ccp.editingNote,
    assembledNote: state.ccp.assembledNote,
    subActions: state.ccp.subActions,
    createAssembledNote: state.ccp.createAssembledNote
  }))

  useEffect(() => {
    setOrders(filterActionsByActionType(rules, actions, subActions, 'Order'))
    setScheduling(filterActionsByActionType(rules, actions, subActions, 'Schedule'))
    setRx(filterActionsByActionType(rules, actions, subActions, 'Rx'))
    setPatientEd(filterActionsByActionType(rules, actions, subActions, 'Patient Education'))
    setOrderReferrals(filterActionsByActionType(rules, actions, subActions, 'Order Referral'))
  }, [])

  useEffect(() => {
    dispatch(generateNote(orders, scheduling, rx, patientEd, orderReferrals))
  }, [orders, scheduling, rx, patientEd, orderReferrals])

  const handleCancelClick = () => {
    dispatch(setEditNote(false))
    dispatch(generateNote(orders, scheduling, rx, patientEd, orderReferrals))
    setNoteEdited(false)
  }

  const handleUpdateAction = (target, action) => {
    dispatch(updateWrapUpAction(target, action))

    if (!noteEdited) {
      dispatch(generateNote(orders, scheduling, rx, patientEd, orderReferrals))
    }
  }

  const handleUpdateAssembledNote = (value) => {
    dispatch(updateAssembledNote(value))

    if (!noteEdited) {
      setNoteEdited(true)
    }
  }

  return (
    <div>
      <h2>Step 3: Wrap Up</h2>
      <Container fluid className='border'>
        <Row>
          <Col md={5}>
            <Container fluid id='orders' className='shadow-sm my-2 py-2'>
              <Form>
                <Row>
                  <Col className='mb-3' xs={12}>
                    <h3 className='h5 mb-1'>Orders</h3>
                    {
                      orders.length > 0
                      && (
                        <>
                          {
                            orders.map((action) => (
                              <div className='custom-control custom-switch' key={action.actionId}>
                                <input
                                  type='checkbox'
                                  className='custom-control-input'
                                  id={action.name}
                                  name={action.key}
                                  disabled={encounter.status.status === 'FINISHED'}
                                  checked={isChecked(rules, actions, action.key)}
                                  onChange={(event) => handleUpdateAction(event.target, action)}
                                />
                                <label className='custom-control-label' htmlFor={action.name}>
                                  [{action.orderKey}] {action.description}
                                </label>
                              </div>
                            ))
                          }
                        </>
                      )
                    }
                    {
                      rx.length > 0
                      && (
                        <>
                          {
                            rx.map((action) => (
                              <div className='custom-control custom-switch' key={action.actionId}>
                                <input
                                  type='checkbox'
                                  className='custom-control-input'
                                  id={action.actionId}
                                  name={action.key}
                                  checked={isChecked(rules, actions, action.key)}
                                  disabled={encounter.status.status === 'FINISHED'}
                                  onChange={(event) => handleUpdateAction(event.target, action)}
                                />
                                <label className='custom-control-label' htmlFor={action.actionId}>
                                  [{action.orderKey}] {action.description}
                                </label>
                              </div>
                            ))
                          }
                        </>
                      )
                    }
                    {
                      rx.length === 0 && orders.length === 0 && 'No orders selected.'
                    }
                  </Col>
                  <Col xs={12} className='mb-3'>
                    <h3 className='h5 mb-1'>Referrals</h3>
                    {
                      scheduling.length > 0 || orderReferrals.length > 0
                        ? (
                          <>
                            {
                              scheduling.map((action) => (
                                <div className='custom-control custom-switch' key={action.actionId}>
                                  <input
                                    type='checkbox'
                                    className='custom-control-input'
                                    id={action.name}
                                    name={action.key}
                                    checked={isChecked(rules, actions, action.key)}
                                    disabled={encounter.status.status === 'FINISHED'}
                                    onChange={(event) => handleUpdateAction(event.target, action)}
                                  />
                                  <label className='custom-control-label' htmlFor={action.name}>
                                    {action.description}
                                  </label>
                                </div>
                              ))
                            }
                            {
                              orderReferrals.map((action) => (
                                <div className='custom-control custom-switch' key={action.actionId}>
                                  <input
                                    type='checkbox'
                                    className='custom-control-input'
                                    id={action.name}
                                    name={action.key}
                                    checked={isChecked(rules, actions, action.key)}
                                    disabled={encounter.status.status === 'FINISHED'}
                                    onChange={(event) => handleUpdateAction(event.target, action)}
                                  />
                                  <label className='custom-control-label' htmlFor={action.name}>
                                    [{action.orderKey}] {action.description}
                                  </label>
                                </div>
                              ))
                            }
                          </>
                        )
                        : 'No appointment referrals selected.'
                    }
                  </Col>
                  <Col xs={12} className='mb-3'>
                    <h3 className='h5 mb-1'>Patient Ed</h3>
                    {
                      patientEd.length > 0
                        ? (
                          <>
                            {
                              patientEd.map((action) => (
                                <div className='custom-control custom-switch' key={action.actionId}>
                                  <input
                                    type='checkbox'
                                    className='custom-control-input'
                                    id={action.name}
                                    name={action.key}
                                    checked={isChecked(rules, actions, action.key)}
                                    disabled={encounter.status.status === 'FINISHED'}
                                    onChange={(event) => handleUpdateAction(event.target, action)}
                                  />
                                  <label className='custom-control-label' htmlFor={action.name}>
                                    {action.description}
                                  </label>
                                </div>
                              ))
                            }
                          </>
                        )
                        : 'No Patient Education will be sent.'
                    }
                  </Col>
                </Row>
              </Form>
            </Container>
          </Col>
          <Col md={7}>
            <Container fluid id='note' className='shadow-sm my-2 py-2'>
              <Row>
                <Col xs={6}>
                  <h3 className='h5'>Assembled Note:</h3>
                </Col>
                {
                  createAssembledNote.success && (
                    <Col xs={6} className='text-right'>
                      {
                        encounter.status.status !== 'FINISHED' && (
                          <>
                            {
                              editing && (
                                <Button onClick={() => handleCancelClick()} className='edit-note-cancel-btn mr-2' size='sm'>
                                  Cancel
                                </Button>
                              )
                            }
                            <Button onClick={() => dispatch(setEditNote(!editing))} className='edit-note-btn' size='sm'>
                              {editing ? 'Done' : 'Edit'}
                            </Button>
                          </>
                        )
                      }
                    </Col>
                  )
                }
              </Row>
              {
                createAssembledNote.loading && (
                  <Spinner />
                )
              }
              {
                createAssembledNote.success && (
                  <>
                    {
                      editing
                        ? (
                          <div className='mt-2'>
                            <Form.Control
                              as='textarea'
                              value={assembledNote}
                              style={{ height: '77vh', fontSize: '.75rem' }}
                              onChange={(event) => handleUpdateAssembledNote(event.target.value)}
                            />
                          </div>
                        )
                        : (
                          <div style={{ whiteSpace: 'pre-wrap' }} className='normal mt-2'>
                            {assembledNote}
                          </div>
                        )
                    }
                  </>
                )
              }
            </Container>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default WrapUp
